(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-stock-status"] && !Shopify.designMode) return;
  try {
    class TilrayStockStatus extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;

      // Listen for variant changes
      document.addEventListener('variant:changed', this.handleVariantChange.bind(this));
    }

    handleVariantChange(event) {
      if (event.detail && event.detail.productId === this.productId) {
        // The stock status will be updated via section rendering
        // This is a placeholder for any client-side updates needed
      }
    }
  }

  if (!customElements.get('custom-stock-status')) {
    customElements.define('custom-stock-status', TilrayStockStatus);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-variant-formats"] && !Shopify.designMode) return;
  try {
    class TilrayAvailableFormats extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('.tilray-formats__btn');
      this.variantInput = this.querySelector('[ref="variantInput"]');
      this.priceDisplay = this.querySelector('[ref="priceDisplay"]');
      this.currentPriceEl = this.querySelector('[ref="currentPrice"]');
      this.comparePriceEl = this.querySelector('[ref="comparePrice"]');
      this.productData = JSON.parse(this.querySelector('[ref="productJson"]')?.textContent || '{}');
      this.productUrl = this.dataset.productUrl;
      this.useCurrency = this.dataset.useCurrency === 'true';

      this.bindEvents();
    }

    bindEvents() {
      this.buttons.forEach(button => {
        button.addEventListener('click', this.handleButtonClick.bind(this));
      });
    }

    handleButtonClick(event) {
      const button = event.currentTarget;
      
      // Don't allow selecting unavailable variants if configured
      if (button.classList.contains('tilray-formats__btn--unavailable')) {
        return;
      }

      // Update selected state
      this.buttons.forEach(btn => {
        btn.classList.remove('tilray-formats__btn--selected');
        btn.setAttribute('aria-checked', 'false');
      });
      button.classList.add('tilray-formats__btn--selected');
      button.setAttribute('aria-checked', 'true');

      // Get variant data
      const variantId = button.dataset.variantId;
      const variant = this.productData.variants?.find(v => v.id === parseInt(variantId, 10));

      // Update hidden input
      if (this.variantInput) {
        this.variantInput.value = variantId;
      }

      // Update price display
      this.updatePriceDisplay(button);

      // Update URL
      this.updateUrl(variantId);

      // Dispatch variant changed event for other blocks
      this.dispatchVariantChanged(button, variant);
    }

    updatePriceDisplay(button) {
      if (!this.priceDisplay) return;

      const price = button.dataset.variantPriceFormatted;
      const comparePrice = button.dataset.variantComparePriceFormatted;
      const hasComparePrice = parseInt(button.dataset.variantComparePrice, 10) > parseInt(button.dataset.variantPrice, 10);

      if (this.currentPriceEl) {
        this.currentPriceEl.textContent = price;
        this.currentPriceEl.classList.toggle('tilray-formats__current-price--sale', hasComparePrice);
      }

      if (this.comparePriceEl) {
        if (hasComparePrice) {
          this.comparePriceEl.textContent = comparePrice;
          this.comparePriceEl.style.display = '';
        } else {
          this.comparePriceEl.style.display = 'none';
        }
      } else if (hasComparePrice && this.priceDisplay) {
        // Create compare price element if it doesn't exist
        const comparePriceSpan = document.createElement('span');
        comparePriceSpan.className = 'tilray-formats__compare-price';
        comparePriceSpan.setAttribute('ref', 'comparePrice');
        comparePriceSpan.textContent = comparePrice;
        this.priceDisplay.insertBefore(comparePriceSpan, this.currentPriceEl);
        this.comparePriceEl = comparePriceSpan;
      }
    }

    updateUrl(variantId) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }

    dispatchVariantChanged(button, variant) {
      const variantData = {
        id: parseInt(button.dataset.variantId, 10),
        available: button.dataset.variantAvailable === 'true',
        price: parseInt(button.dataset.variantPrice, 10),
        compare_at_price: parseInt(button.dataset.variantComparePrice, 10) || null,
        price_formatted: button.dataset.variantPriceFormatted,
        compare_at_price_formatted: button.dataset.variantComparePriceFormatted,
        title: button.dataset.variantTitle,
        sku: button.dataset.variantSku,
        inventory_quantity: parseInt(button.dataset.variantInventoryQuantity, 10),
        inventory_management: button.dataset.variantInventoryManagement,
        quantity_rule: {
          min: parseInt(button.dataset.quantityRuleMin, 10) || 1,
          max: parseInt(button.dataset.quantityRuleMax, 10) || 99,
          increment: parseInt(button.dataset.quantityRuleIncrement, 10) || 1
        }
      };

      // Merge with full variant data if available
      const fullVariant = variant || variantData;

      // Dispatch custom event
      document.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          variant: fullVariant,
          sectionId: this.dataset.sectionId,
          productId: this.dataset.productId
        }
      }));

      // Also dispatch on the element itself
      this.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          variant: fullVariant,
          sectionId: this.dataset.sectionId,
          productId: this.dataset.productId
        }
      }));
    }
  }

  if (!customElements.get('custom-variant-formats')) {
    customElements.define('custom-variant-formats', TilrayAvailableFormats);
  }
  } catch(e) { console.error(e); }
})();

})();
